/**
 * URLs del PHP legacy → rutas de la SPA (plan §17.2, paso 5). Al hacer el corte,
 * `platform.consaludenarm.com` apunta a la SPA y los marcadores, correos viejos y enlaces de la
 * app siguen funcionando. Los IDs cifrados del PHP (`?id=…`) no se traducen: se lleva al listado.
 *
 * Los retornos de pago del PHP (PayPal `ExecutePayment`, páginas de pago completado o rechazado,
 * Stripe) se mandan al legacy, con su query intacta, para que un pago iniciado antes del corte
 * se termine de procesar allá.
 */
export type Destino = { tipo: 'interna'; ruta: string } | { tipo: 'externa'; url: string };

const MAPA: [RegExp, string][] = [
  [
    /^\/inicio\/(inicio1|inicio2|test_video|video_in_app|video_links|libro|manuales\/manual)$/,
    '/inicio',
  ],
  [/^\/inicio\/manuales$/, '/inicio'],
  [/^\/inicio\/avances(\/.*)?$/, '/avances'],
  [/^\/inicio\/busqueda$/, '/busqueda'],
  [/^\/inicio\/constancias$/, '/constancias'],
  [/^\/inicio\/cuenta(\/.*)?$/, '/cuenta'],
  [/^\/inicio\/opinion$/, '/opinion'],
  [/^\/inicio\/puntajes-enarm$/, '/puntajes-enarm'],
  [/^\/inicio\/licencias$/, '/licencias'],
  [/^\/inicio\/pagar$/, '/licencias'],
  [/^\/inicio\/live$/, '/live/grabaciones'],
  [/^\/inicio\/live\/historico\d?$/, '/live/grabaciones'],
  [/^\/inicio\/simulador(-v2)?(\/.*)?$/, '/simulador'],
  [/^\/inicio\/curso$/, '/curso-enarm'],
  [/^\/inicio\/curso-enarm$/, '/curso-enarm'],
  [/^\/inicio\/curso-enarm\/avances$/, '/curso-enarm/avances'],
  [/^\/inicio\/curso-enarm\/clases(\/.*)?$/, '/curso-enarm/clases'],
  [/^\/inicio\/curso-enarm\/talleres(\/.*)?$/, '/curso-enarm/talleres'],
  [/^\/inicio\/curso-enarm\/examenes(-prime)?(\/.*)?$/, '/curso-enarm/examenes-prime'],
  [/^\/inicio\/curso-enarm\/temario$/, '/curso-enarm/temario'],
  [/^\/inicio\/curso-enarm\/temario\/organizar$/, '/curso-enarm/temario/organizar'],
  [/^\/inicio\/curso-enarm\/temario\/consultar(\/.*)?$/, '/curso-enarm/temario/plan'],
  [/^\/inicio\/curso-enarm\/biblioteca$/, '/curso-enarm/biblioteca'],
  [
    /^\/inicio\/curso-enarm\/biblioteca\/presentaciones(\/.*)?$/,
    '/curso-enarm/biblioteca/presentaciones',
  ],
  [
    /^\/inicio\/curso-enarm\/biblioteca\/flashcards(\/flashcard)?$/,
    '/curso-enarm/biblioteca/flashcards',
  ],
  [
    /^\/inicio\/curso-enarm\/biblioteca\/flashcards-evaluadas-enarm$/,
    '/curso-enarm/biblioteca/flashcards-evaluadas',
  ],
  [/^\/inicio\/curso-enarm\/biblioteca\/video-tips(\/.*)?$/, '/curso-enarm/biblioteca/video-tips'],
  [/^\/inicio\/curso-enarm\/biblioteca\/guias-gpc$/, '/curso-enarm/biblioteca/guias-gpc'],
  [
    /^\/inicio\/curso-enarm\/biblioteca\/resumenes-gpc(\/.*)?$/,
    '/curso-enarm/biblioteca/resumenes-gpc',
  ],
  // D15: secciones dormidas que no se portaron.
  [
    /^\/inicio\/curso-enarm\/biblioteca\/(pdfs|ingles-medico|flashcards-ingles-medico)$/,
    '/curso-enarm/biblioteca',
  ],
  [/^\/inicio\/manuales\/manual-algoritmos$/, '/manuales/algoritmos'],
  [/^\/inicio\/manuales\/manual-clasificaciones-y-tablas$/, '/manuales/clasificaciones-y-tablas'],
  [/^\/inicio\/manuales\/manual-enarm-plus$/, '/manuales/enarm-plus'],
  [/^\/inicio\/manuales\/manual-ingles-medico(-advance)?$/, '/manuales/ingles-medico'],
  [/^\/inicio\/manuales\/manual-mnemotecnias(-advance)?$/, '/manuales/mnemotecnias'],
  [/^\/inicio\/manuales\/manual-ultraresumenes(-advance)?$/, '/manuales/ultra-resumenes'],
  [/^\/enlace-de-recuperacion$/, '/recuperar-contrasenia'],
  [/^\/(logout|navegadores)$/, '/login'],
];

/** Retornos de pago del PHP: se terminan en el legacy. */
const PAGOS_LEGACY =
  /^\/inicio\/pagar\/(ExecutePayment|pago-completado|pago-rechazado|stripe\/.+)$/;

function normalizar(pathname: string) {
  const p = pathname.replace(/\/index\.php$/i, '').replace(/\/+$/, '');
  return p === '' ? '/' : p;
}

export function destinoLegacy(pathname: string, search: string, legacyUrl: string): Destino {
  const p = normalizar(pathname);
  const base = legacyUrl.replace(/\/$/, '');
  if (p === '/legacy' || p.startsWith('/legacy/')) {
    return { tipo: 'externa', url: `${base}${p.slice('/legacy'.length) || '/'}${search}` };
  }
  if (PAGOS_LEGACY.test(p)) return { tipo: 'externa', url: `${base}${p}/${search}` };
  for (const [re, ruta] of MAPA) if (re.test(p)) return { tipo: 'interna', ruta };
  return { tipo: 'interna', ruta: '/inicio' };
}
